/*
 * Copyright (c) 2020, WSO2 Inc. (http://www.wso2.com). All Rights Reserved.
 *
 * This software is the property of WSO2 Inc. and its suppliers, if any.
 * Dissemination of any information or reproduction of any material contained
 * herein is strictly forbidden, unless permitted by WSO2 in accordance with
 * the WSO2 Commercial License available at http://wso2.com/licenses.
 * For specific language governing the permissions and limitations under
 * this license, please see the license as well as any agreement you’ve
 * entered into with WSO2 governing the purchase of this software and any
 * associated services.
 */

import { makeStyles } from "@material-ui/core/styles";

export const useStyles = makeStyles((theme) => ({
    signInContainer: {
        height: '100vh',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center'
    },
    signInText: {
        fontFamily: 'GilmerBold',
        fontSize: '29px',
        margin: '50px'
    },
    tryAgainBtn: {
        margin: '20px',
        textTransform: "capitalize"
    },
    loaderContainer: {
        display: "flex",
        alignItems: "center",
        justifyContent: "center"
    },
}));
